/**
 * @Author: Zewei
 * @Date:   2018-01-19T14:39:17+08:00
 * @Last modified by:
 * @Last modified time: 2018-02-11T10:57:35+08:00
 */

import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';

import user from './user-reducer';
import systemSetting from './system-setting-reducer.js';
import departmentStructure from './department-structure-reducer.js';
import employeeManagement from './employee-management-reducer.js';
import employee from './employee-reducer.js';
import approval from './approval-reducer.js';
import announcement from './announcement-reducer.js'
import dailyReports from './daily-report-reducer.js';
// import monthlyReport from './monthly-report-reducer';
import attendance from './attendance-reducer';
import training from './training-reducer';

import workReport from './work-report-reducer';
import recruitment from './recruitment-reducer';

import salaryAllowance from './salary-allowance-reducer';

// 将该目录下 各具体reducers 引入， 将其 合并
 export default combineReducers({
     routing: routerReducer,
     user,
     systemSetting,
     departmentStructure,
     employeeManagement,
     dailyReports,
     employee,
     announcement,
     // monthlyReport,
     attendance,
     workReport,
     training,
     recruitment,
     salaryAllowance,
     approval
 })



// WEBPACK FOOTER //
// ./src/reducers/index.js